import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const renderAcceptedLikeInfo = label => (
  <div className="task-accept-buttons task-accept-info">
    <Button className="icon-check accept-info" color="transparent" disabled>
      {label}
    </Button>
  </div>
);

const renderRejectedLikeInfo = label => (
  <div className="task-accept-buttons task-accept-info">
    <Button className="icon-close accept-info" color="transparent" disabled>
      {label}
    </Button>
  </div>
);

class AcceptInfo extends PureComponent {
  render() {
    const {
      assignedCompany: {
        type_task_user_status: { code, name },
      },
    } = this.props;

    switch (code) {
      case 'assigned':
      case 'accepted': {
        return renderAcceptedLikeInfo(name);
      }
      case 'declined':
      case 'rejected':
      case 'deleted': {
        return renderRejectedLikeInfo(name);
      }
      default:
        return null;
    }
  }
}

AcceptInfo.propTypes = {
  assignedCompany: PropTypes.shape({
    type_task_user_status: PropTypes.shape({
      code: PropTypes.string,
    }),
  }),
};

export default AcceptInfo;
